/**
 * Tagurile expresive ([warmly], [confidently]) sunt DIRECȚII DE INTERPRETARE
 * pentru sinteza ElevenLabs, nu conținut - vezi `packages/sdk/src/voice/tags.ts`
 * pentru povestea completă (raportat 9 aug 2026: vizitatorul le-a văzut scrise
 * în panou și sub orb).
 *
 * Set ÎNCHIS, deliberat: o curățare generică de paranteze drepte ar mutila
 * numele de produse („Bosch [GKS 190]"). Canonic aici - sdk-ul (curățare la
 * randare, un singur tag de la început) și dashboard-ul (curățare la randare,
 * toate aparițiile, inclusiv la mijloc de text) trag din aceeași listă.
 */
export const EXPRESSIVE_TAGS = ["[warmly]", "[confidently]"];

/**
 * Scoate TOATE aparițiile tagurilor expresive cunoscute, oriunde ar fi -
 * început, mijloc de text, repetate. Spre deosebire de `stripExpressiveTag`
 * din sdk (care curăță doar UN tag de la început, pentru caption-ul live sub
 * orb), aici textul e deja complet la randare - un transcript stocat poate
 * avea taguri împrăștiate în mijlocul răspunsului.
 *
 * Ce NU se curăță e la fel de important: paranteze drepte care nu sunt din
 * setul cunoscut (`[GKS 190]`, `[2 buc]`) trec neatinse.
 */
function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function stripAllExpressiveTags(text: string): string {
  let result = text;
  for (const tag of EXPRESSIVE_TAGS) {
    // case-insensitive, ca la stripExpressiveTag din sdk.
    result = result.replace(new RegExp(escapeRegExp(tag), "gi"), "");
  }
  // taguri repetate/lipite pot lăsa spații duble - normalizăm doar spațiile
  // simple, nu tot whitespace-ul (nu vrem să atingem newline-urile din markdown).
  return result.replace(/ {2,}/g, " ").trim();
}
